module.exports = __webpack_public_path__ + "static/kalnikova-219a5c0cf2fe31dbe8149b0290e486c8.jpg";